<span *ngIf="errorMessage !== undefined" class="errorMessage">
  {{ errorMessage }}
</span>
